import Startend from './StartendModule'
import AudienceId from './AudienceIdModule'

window.VideogPlayerQuerystring = {
  Startend,
  AudienceId,
}
